(() => {
  // Scroll-triggered reveal (IntersectionObserver)
  if ("IntersectionObserver" in window) {
    // Fire early on ALL screens so content reveals as it scrolls into view (not after)
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const rawDelay = Number(entry.target.dataset.ccDelay || 0);
            // Cap delay at 120ms so staggered reveals never feel sluggish
            const delay = Math.min(rawDelay * 0.5, 120);
            setTimeout(() => entry.target.classList.add("cc-in"), delay);
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.02, rootMargin: "0px 0px 15% 0px" }
    );
    document.querySelectorAll(".cc-reveal").forEach((el) => io.observe(el));
  } else {
    document.querySelectorAll(".cc-reveal").forEach((el) => el.classList.add("cc-in"));
  }

  // Header pop-on-scroll
  const SCROLL_THRESHOLD = 100;
  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      if (window.scrollY > SCROLL_THRESHOLD) {
        document.body.classList.add("cc-scrolled");
      } else {
        document.body.classList.remove("cc-scrolled");
      }
      ticking = false;
    });
  };
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });

  // ====================================================
  // Beach widget: NWS weather + NOAA tides
  // ====================================================
  const iconFor = (short) => {
    const s = (short || "").toLowerCase();
    if (s.includes("thunder")) return "⛈️";
    if (s.includes("rain") || s.includes("shower")) return "🌧️";
    if (s.includes("snow") || s.includes("flurries")) return "❄️";
    if (s.includes("fog") || s.includes("haze")) return "🌫️";
    if (s.includes("cloudy") && !s.includes("partly")) return "☁️";
    if (s.includes("partly") || s.includes("mostly cloudy")) return "⛅";
    if (s.includes("clear") || s.includes("sunny")) return "☀️";
    if (s.includes("wind")) return "💨";
    return "🌤️";
  };

  const fmtTime = (iso) => {
    try {
      const d = new Date(iso.replace(" ", "T"));
      let h = d.getHours();
      const m = d.getMinutes();
      const ampm = h >= 12 ? "PM" : "AM";
      h = h % 12 || 12;
      return `${h}:${m.toString().padStart(2, "0")} ${ampm}`;
    } catch (e) { return ""; }
  };

  const loadWeather = async (widget) => {
    const lat = widget.dataset.lat;
    const lon = widget.dataset.lon;
    if (!lat || !lon) return;
    try {
      const pointsRes = await fetch(`https://api.weather.gov/points/${lat},${lon}`);
      if (!pointsRes.ok) throw new Error("points");
      const pointsData = await pointsRes.json();
      const forecastUrl = pointsData.properties && pointsData.properties.forecast;
      if (!forecastUrl) throw new Error("no forecast url");
      const forecastRes = await fetch(forecastUrl);
      if (!forecastRes.ok) throw new Error("forecast");
      const forecastData = await forecastRes.json();
      const today = forecastData.properties.periods[0];
      const iconEl = widget.querySelector("[data-cc-weather-icon]");
      const primaryEl = widget.querySelector("[data-cc-weather-primary]");
      const secondaryEl = widget.querySelector("[data-cc-weather-secondary]");
      if (iconEl) iconEl.textContent = iconFor(today.shortForecast);
      if (primaryEl) primaryEl.textContent = `${today.temperature}°${today.temperatureUnit} · ${today.shortForecast}`;
      if (secondaryEl) secondaryEl.textContent = `${today.name} · ${today.windSpeed} ${today.windDirection}`;
    } catch (e) {
      const primaryEl = widget.querySelector("[data-cc-weather-primary]");
      const secondaryEl = widget.querySelector("[data-cc-weather-secondary]");
      if (primaryEl) primaryEl.textContent = "Check local forecast";
      if (secondaryEl) secondaryEl.textContent = "Weather service unavailable";
    }
  };

  const loadTides = async (widget) => {
    const station = widget.dataset.station;
    if (!station) return;
    try {
      const url = `https://api.tidesandcurrents.noaa.gov/api/prod/datagetter?station=${station}&product=predictions&date=today&datum=MLLW&format=json&interval=hilo&units=english&time_zone=lst_ldt`;
      const res = await fetch(url);
      if (!res.ok) throw new Error("tides");
      const data = await res.json();
      const preds = (data && data.predictions) || [];
      if (!preds.length) throw new Error("no preds");
      const lines = preds.slice(0, 4).map((p) => {
        const label = p.type === "H" ? "High" : "Low";
        return `${fmtTime(p.t)} ${label}`;
      });
      const el = widget.querySelector("[data-cc-tides-times]");
      if (el) el.textContent = lines.join(" · ");
    } catch (e) {
      const el = widget.querySelector("[data-cc-tides-times]");
      if (el) el.textContent = "Check NOAA for today's tides";
    }
  };

  document.querySelectorAll("[data-cc-widget]").forEach((w) => {
    loadWeather(w);
    loadTides(w);
  });
})();
